import * as profileApi from '../../api/profile-api';
import { IProfile } from '../../models/profile';
import { IErrorResult, IResult } from '../../models/result-models';
import { getErrorMessage } from '../../utils/error-handling';
import { apiCallError, beginApiCall } from '../api/api-status-action';

export const LOAD_PROFILE_SUCCESS = 'LOAD_PROFILE_SUCCESS';
export const SAVE_PATIENT_CONSENT_SUCCESS = 'SAVE_PATIENT_CONSENT_SUCCESS';
export const SAVE_PROFILE_SUCCESS = 'SAVE_PROFILE_SUCCESS';

export const LOAD_PROFILE_ERROR = 'LOAD_PROFILE_ERROR';
export const SAVE_PROFILE_ERROR = 'SAVE_PROFILE_ERROR';

export const ACTION_PROFILE_FATAL = 'ACTION_PROFILE_FATAL';

// Actions
const loadProfileSuccess = (result: IResult<IProfile>) => ({
    type: LOAD_PROFILE_SUCCESS,
    result,
});

const savePatientConsentSuccess = () => ({
    type: SAVE_PATIENT_CONSENT_SUCCESS,
});

const saveProfileSuccess = (result: IResult<IProfile>) => ({
    type: SAVE_PROFILE_SUCCESS,
    result,
});

const loadProfileError = (error: any) => ({
    type: LOAD_PROFILE_ERROR,
    result: error,
});

const saveProfileError = (result: IResult<IProfile>) => ({
    type: SAVE_PROFILE_ERROR,
    result,
});

const actionProfileFatal = (payload: IErrorResult) => ({
    type: ACTION_PROFILE_FATAL,
    payload,
});

// Thunks
export const loadProfile = () => {
    return async (dispatch: any) => {
        try {
            dispatch(beginApiCall());
            const result = await profileApi.getProfile();
            dispatch(loadProfileSuccess(result));
        } catch (error) {
            dispatch(apiCallError(error));
            throw error;
        }
    };
};

export const savePatientConsent = () => {
    return async (dispath: any) => {
        try {
            dispath(beginApiCall());
            await profileApi.savePatientConsent();
            dispath(savePatientConsentSuccess());
        } catch (error) {
            dispath(apiCallError(error));
            throw error;
        }
    };
};

export const saveProfile = (profile: IProfile, saveConsent: boolean) => {
    return async (dispatch: any) => {
        try {
            dispatch(beginApiCall());
            const result = await profileApi.saveProfile(profile);
            if (result.ok) {
                if (saveConsent) {
                    await profileApi.savePatientConsent();
                    profile.patientConsent = true;
                }
                dispatch(saveProfileSuccess(result));
            } else {
                dispatch(saveProfileError(result));
                dispatch(
                    apiCallError({
                        name: '',
                        message: 'error validating profile save payload',
                    })
                );
            }
            return result.ok;
        } catch (error) {
            dispatch(
                actionProfileFatal({ errorMessage: getErrorMessage(error) })
            );
            dispatch(apiCallError(error));
            throw error;
        }
    };
};

export const optInOutRequest = (
    email: string,
    phoneNumber: string,
    optInValue: boolean
) => {
    return async (dispatch: any) => {
        try {
            dispatch(beginApiCall());
            const result = await profileApi.optInOutRequest(
                email,
                phoneNumber,
                optInValue
            );
            if (!result.ok) {
                dispatch(
                    apiCallError({
                        name: '',
                        message: 'error opting in to SMS notifications',
                    })
                );
            }
            return result.ok;
        } catch (error) {
            dispatch(
                actionProfileFatal({ errorMessage: getErrorMessage(error) })
            );
            dispatch(apiCallError(error));
            throw error;
        }
    };
};
